import { lazy } from 'react';
import OffersRoot, { pricingLoader } from './offers';
import {
  ABOUT_US,
  AGENDA,
  RECHARGES,
  SETTING,
  ADMIN_ADMINISTRATION,
  ADMIN_HOME,
  ADMIN_LINK,
  ADMIN_LOGIN,
  ADMIN_PERSONALIZE,
  ADMIN_PRODUCTS,
  ADMIN_SETTING,
  ADMIN_SYSTEM_JOBS,
  ADMIN_USERS,
  COOKIE_POLICY,
  DELETE_ACCOUNT,
  EMAIL_CONFIRMATION,
  HOME,
  LEGAL_NOTICE,
  LINK,
  LINK_TOKEN,
  LOGIN,
  MOBILE_CHECKOUT,
  MOBILE_CHECKOUT_CANCEL,
  MOBILE_CHECKOUT_SUCCESS,
  OFFERS,
  PASSWORD_CHANGE,
  PASSWORD_RECOVERY,
  PAYMENT_SUCCESS,
  POLITICS,
  PROFILE,
  REGISTER,
  REGISTER_INVITATION,
  TERMS_AND_CONDITIONS,
  USER_DATA,
} from './paths';

// AUTH
const LoginEmail = lazy(() => import('../../pages/Auth/LoginEmail'));
const RegisterEmail = lazy(() => import('../../pages/Auth/RegisterEmail'));
const PasswordRecovery = lazy(() => import('../../pages/Auth/PasswordRecovery'));
const PasswordChange = lazy(() => import('../../pages/Auth/PasswordChange'));
const EmailConfirmation = lazy(() => import('../../pages/Auth/EmailConfirmation'));

// CLIENT
const Home = lazy(() => import('../../pages/Home'));
const AboutUs = lazy(() => import('../../pages/AboutUs'));
const Profile = lazy(() => import('../../pages/Profile/Profile'));
const SettingsPage = lazy(() => import('../../pages/Settings/Settings'));
const AgendaPage = lazy(() => import('../../pages/Agenda/AgendaPage'));
const RechargesPage = lazy(() => import('../../pages/Recharges/RechargesPage'));
const LinkPage = lazy(() => import('../../pages/Link/LinkPage'));

// STATIC PAGES
const TermConditions = lazy(() => import('../../pages/Others/TermConditions'));
const Politics = lazy(() => import('../../pages/Others/Politics'));
const AvisoLegal = lazy(() => import('../../pages/Others/AvisoLegal'));
const PoliticaCookies = lazy(() => import('../../pages/Others/PoliticaCookies'));
const UserData = lazy(() => import('../../pages/Others/UserData'));
const DeleteAccount = lazy(() => import('../../pages/Others/DeleteAccount'));

// PAYMENTS
const PaymentSuccess = lazy(() => import('../../pages/Payments/PaymentSuccess'));
const MobileCheckout = lazy(() => import('../../pages/Payments/MobileCheckout'));
const MobileCheckoutSuccess = lazy(() => import('../../pages/Payments/MobileCheckoutSuccess'));
const MobileCheckoutCancel = lazy(() => import('../../pages/Payments/MobileCheckoutCancel'));

// 404
const Page404 = lazy(() => import('../../pages/Page404'));

// ADMIN
const Dashboard = lazy(() => import('../../pages/Admin/Dashboard'));
const Login = lazy(() => import('../../pages/Admin/Login'));
const Products = lazy(() => import('../../pages/Admin/Products'));
const Users = lazy(() => import('../../pages/Admin/Users'));
const PayLinks = lazy(() => import('../../pages/Admin/PayLinks'));
const Administration = lazy(() => import('../../pages/Admin/Administration'));
const Settings = lazy(() => import('../../pages/Admin/Settings'));
const Personalize = lazy(() => import('../../pages/Admin/Personalize'));
const SystemJobs = lazy(() => import('../../pages/Admin/SystemJobs'));

const publicRoutes = [
  // AUTH
  { path: LOGIN, component: LoginEmail, type: 'client' },
  { path: REGISTER, component: RegisterEmail, type: 'client' },
  { path: REGISTER_INVITATION, component: RegisterEmail, type: 'client' },
  { path: EMAIL_CONFIRMATION, component: EmailConfirmation, type: 'client' },
  { path: PASSWORD_RECOVERY, component: PasswordRecovery, type: 'client' },
  { path: PASSWORD_CHANGE, component: PasswordChange, type: 'client' },
  // ADMIN AUTH
  { path: ADMIN_LOGIN, component: Login, type: 'admin' },
  // CLIENT
  { path: PROFILE, component: Profile, type: 'client' },
  { path: SETTING, component: SettingsPage, type: 'client' },
  // PUBLIC
  { path: AGENDA, component: AgendaPage, type: 'client' },
  { path: RECHARGES, component: RechargesPage, type: 'client' },
  { path: ABOUT_US, component: AboutUs, type: 'client' },
  { path: HOME, component: Home, type: 'client' },
  { path: '*', component: Page404, type: 'client' },
  {
    path: OFFERS,
    component: OffersRoot,
    type: 'client',
    loader: pricingLoader,
  },
  { path: TERMS_AND_CONDITIONS, component: TermConditions, type: 'client' },
  { path: POLITICS, component: Politics, type: 'client' },
  { path: LEGAL_NOTICE, component: AvisoLegal, type: 'client' },
  { path: COOKIE_POLICY, component: PoliticaCookies, type: 'client' },
  { path: USER_DATA, component: UserData, type: 'client'},
  { path: DELETE_ACCOUNT, component: DeleteAccount, type: 'client' },
  { path: LINK, component: LinkPage, type: 'client' },
  { path: LINK_TOKEN, component: LinkPage, type: 'client' },
  { path: PAYMENT_SUCCESS, component: PaymentSuccess, type: 'client' },
  { path: MOBILE_CHECKOUT, component: MobileCheckout, type: 'client' },
  { path: MOBILE_CHECKOUT_SUCCESS, component: MobileCheckoutSuccess, type: 'client' },
  { path: MOBILE_CHECKOUT_CANCEL, component: MobileCheckoutCancel, type: 'client' },
];

const authProtectedRoutes = [
  // ADMIN
  { path: ADMIN_HOME, component: Dashboard, type: 'admin' },
  { path: ADMIN_PRODUCTS, component: Products, type: 'admin' },
  { path: ADMIN_USERS, component: Users, type: 'admin' },
  { path: ADMIN_LINK, component: PayLinks, type: 'admin' },
  { path: ADMIN_ADMINISTRATION, component: Administration, type: 'admin' },
  { path: ADMIN_SETTING, component: Settings, type: 'admin' },
  { path: ADMIN_PERSONALIZE, component: Personalize, type: 'admin' },
  { path: ADMIN_SYSTEM_JOBS, component: SystemJobs, type: 'admin' },
];

export { publicRoutes, authProtectedRoutes };
